import Cookies from 'js-cookie';

import { COOKIE_NAME_AUTH_APP } from '../constants.ts';

/**
 */
export const getAuthClientCookie = (): string | null => {
  const sessionCookie = Cookies.get(COOKIE_NAME_AUTH_APP);
  if (!sessionCookie) {
    return null;
  }

  return sessionCookie as string;
};

/**
 */
export const updateAuthClientCookie = (updates: string) => {
  // const session = getAuthClientCookie() || {};
  Cookies.set(COOKIE_NAME_AUTH_APP, updates);
};
